"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryStatuses = exports.SignatureEventMap = exports.SignatureTypeEvent = void 0;
// Events
const signatureEvents_1 = require("../events/signatureEvents");
var SignatureTypeEvent;
(function (SignatureTypeEvent) {
    SignatureTypeEvent["SHOW_SIGNATURE"] = "showSignatureEvent";
    SignatureTypeEvent["ERROR_SIGNATURE"] = "errorSignatureEvent";
    SignatureTypeEvent["VALIDATE_SIGNATURE"] = "validateSignatureEvent";
    SignatureTypeEvent["CANCEL_SIGNATURE_FLOW"] = "cancelSignatureEvent";
    SignatureTypeEvent["FINISH_SIGNATURE_FLOW"] = "finishSignatureEvent";
    SignatureTypeEvent["RESET_SIGNATURE_FLOW"] = "resetSignatureEvent";
    SignatureTypeEvent["RETRY_SIGNATURE_FLOW"] = "retrySignatureEvent";
})(SignatureTypeEvent || (exports.SignatureTypeEvent = SignatureTypeEvent = {}));
exports.SignatureEventMap = {
    [SignatureTypeEvent.SHOW_SIGNATURE]: signatureEvents_1.ShowSignatureEvent,
    [SignatureTypeEvent.VALIDATE_SIGNATURE]: signatureEvents_1.ValidateSignatureEvent,
    [SignatureTypeEvent.ERROR_SIGNATURE]: signatureEvents_1.ErrorSignatureEvent,
    [SignatureTypeEvent.CANCEL_SIGNATURE_FLOW]: signatureEvents_1.CancelSignatureEvent,
    [SignatureTypeEvent.FINISH_SIGNATURE_FLOW]: signatureEvents_1.FinishSignatureEvent,
    [SignatureTypeEvent.RETRY_SIGNATURE_FLOW]: signatureEvents_1.RetrySignatureEvent,
    [SignatureTypeEvent.RESET_SIGNATURE_FLOW]: signatureEvents_1.ResetSignatureEvent,
};
exports.RetryStatuses = {
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
};
//# sourceMappingURL=events.types.js.map